import { I as InputIndicator, d as defineCustomElement$1 } from './input-indicator.js';
var SkpInputIndicator = InputIndicator;
var defineCustomElement = defineCustomElement$1;
export { SkpInputIndicator, defineCustomElement };